import styled from "styled-components/macro";
import {useAdUnits, useFetchAdUnits, useV2AdImpression, useV2AdView} from "../../api/ads";
import {useSettings} from "../../store";
import {useFeedback} from "../../store/feedback";
import {useEffect, useRef, useState} from "react";
import {useIsVisible} from "../../utils/visibility";
import {themecolors} from "../../utils/themecolors";

const AdImage = styled.div``;
const AdTitle = styled.div``;
const AdBrand = styled.div``;
const AdText = styled.div``

const SidebarAdUnit = styled(({className, path}) => {

    const {pro_tier} = useSettings();

    const {feedbackCh} = useFeedback();

    const adUnits = useAdUnits();

    const view = useV2AdView(feedbackCh);
    const impress = useV2AdImpression(feedbackCh);

    const fetchAdUnits = useFetchAdUnits(feedbackCh);

    useEffect(() => {
        if (adUnits && adUnits.ads && adUnits.ads.length === 0) fetchAdUnits();
    }, [adUnits])

    if (pro_tier > 0) return null;

    if (!adUnits || !adUnits.ads) return null;

    return (
        <div className={`${className} sponsored ad ad-unit google-ad googleAd google-sponsored-links ads4 fullSizeAd`}>
            <MiniAd adUnits={adUnits} view={view} impress={impress} path={path} />
            <MiniAd adUnits={adUnits} view={view} impress={impress} path={path} />
            <MiniAd adUnits={adUnits} view={view} impress={impress} path={path} />
        </div>
    );
})`
  margin-bottom: 16px;
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
  border-radius: 4px;
  & > * {
    padding: 10px 16px 10px 16px;
  }
  & > *:first-of-type {
    padding-top: 16px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  & > *:last-of-type {
    padding-bottom: 16px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  & > *:hover {
    background: ${({theme}) => theme.color.name === 'dark' ? theme.dark_border : themecolors.light_input};
  }
`;

const MiniAd = styled(({className, adUnits, view, impress, path}) => {

    const [unit, setUnit] = useState(false);
    const [hasViewed, setHasViewed] = useState(false);
    const [lastPath, setLastPath] = useState(path);
    useEffect(() => {
        if (!unit || (lastPath !== path && adUnits?.ads.length > 0)) {
            setUnit(adUnits?.ads.length > 0 ? adUnits.ads.shift() : false);
            setHasViewed(false);
        }
    }, [adUnits, path])

    const ref = useRef();
    const isVisible = useIsVisible(ref);
    useEffect(async () => {
        if (unit && isVisible && !hasViewed) {
            // register view
            setHasViewed(true);
            await view(unit?.impression, unit?.source, "desktop-sidebar");
        }
    }, [isVisible, unit]);

    useEffect(async () => {
        if (unit) {
            // register impression
            await impress(unit?.impression, unit?.source, "desktop-sidebar");
        }
    }, [unit]);

    return unit ? (
        <a ref={ref} className={className} href={unit.url} rel={"nofollow"} target={`_blank`}>
                <AdImage>
                    <img src={unit.image} />
                </AdImage>
                <AdText>
                    <AdTitle>{unit.headline}</AdTitle>
                    <AdBrand>Ad by {unit.brand}</AdBrand>
                </AdText>
        </a>
    ) : <div ref={ref} />;
})`
  display: flex;
  ${AdImage} img {
    min-width: 64px;
    min-height: 64px;
    width: 64px;
    height: 64px;
    border-radius: 4px;
  }
  ${AdTitle} {
    font-weight: 500;
    font-size: 14px;
  }
  ${AdImage} {
    padding-right: 10px;
  }
  ${AdBrand} {
    font-size: 13px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
`;

export default SidebarAdUnit;